// import axios from "axios";
// import { useEffect, useState } from "react";
// import DatePicker from "react-datepicker";
// import Navbar from "../Navbar";
// import Selectitem from ".";
// import { Bar, Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import Footer from "../Footer";
// import OutletSearch from "../SelectSearch/OutletSearch";
// import { MdAutorenew, MdError } from "react-icons/md";

// // Register the necessary components with ChartJS
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const ItemList = () => {
//   const [itemSelected, setItemSelected] = useState(null);
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());
//   const [status, setStatus] = useState(false);
//   const [itemdata, setItemData] = useState([]);
//   const [department, setDepartment] = useState();
//   const [taxable, setTaxable] = useState();
//   const [UOM, setUOM] = useState();
//   const [GroupName, setGroupName] = useState();
//   const [StockType, setStockType] = useState();
//   const [selectedOutlet, setSelectedOutlet] = useState(null);
//   const [databar, setDataBar] = useState([]);
//   const [databartotal, setDataBarTotal] = useState([]);
//   const [datakitchen, setDataKitchen] = useState([]);
//   const [datakitchentotal, setDataKitchenTotal] = useState([]);
//   const [error, setError] = useState(null)
//   const [loading, setLoading] = useState(false);

//   const Url = process.env.REACT_APP_BASE_URL;
//   const token = localStorage.getItem("token");
//   const reversedItemData = itemdata.slice().reverse();

//   const handleItem = async () => {
//     if (!itemSelected || !selectedOutlet) {
//       setError("Please select item and outlet.");
//       return;
//     }

//     setLoading(true);
//     setStatus(true);
//     setError(null);

//     try {
//       const startFormatted = startDate.toISOString().slice(0, 10);
//       const endFormatted = endDate.toISOString().slice(0, 10);

//       const result = await axios.post(
//         `${Url}/purchasefiltervendorwisefrompurchaseitem`,
//         {
//           token: token,
//           item: itemSelected,
//           dateStart: startFormatted,
//           dateEnd: endFormatted,
//           outlet: selectedOutlet,
//         }
//       );

//       setItemData(result.data.data);

//       const firstItem = result.data.data[0];
//       setDepartment(firstItem.Department);
//       setGroupName(firstItem.GroupName);
//       setTaxable(firstItem.Taxable);
//       setUOM(firstItem.UOM);
//       setStockType(firstItem.StockType);

//       const barData = result.data.costCenters?.find(
//         (item) => item.CostCenter === "Bar"
//       );
//       const kitchenData = result.data.costCenters?.find(
//         (item) => item.CostCenter === "Kitchen"
//       );

//       setDataBar(barData?.ItemDetailsList || []);
//       setDataBarTotal(barData?.grand_total || 0);

//       setDataKitchen(kitchenData?.ItemDetailsList || []);
//       setDataKitchenTotal(kitchenData?.grand_total || 0);

//     } catch (err) {
//       console.log(err);
//       setItemData([]);
//       setError("Failed to fetch data. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const changeItem = (e) => {
//     const ItemName = e;
//     setItemSelected(ItemName);
//   };

//   const calculateGrandTotals = () => {
//     let totalQty = 0;
//     let totalAmount = 0;
//     let count = itemdata.length;

//     itemdata.forEach((element) => {
//       totalQty += parseFloat(element.UnitsOrdered) || 0;
//       totalAmount += parseFloat(element.Total) || 0;
//     });

//     return { count, totalQty, totalAmount };
//   };

//   const { count, totalQty, totalAmount } = calculateGrandTotals();

//   const chartData = {
//     labels: reversedItemData.map((item) =>
//       new Date(item.ReceivedDate).toLocaleDateString("en-GB", {
//         weekday: "short",
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       })
//     ),
//     datasets: [
//       {
//         label: "Price vs Time Chart",
//         backgroundColor: "rgb(255, 99, 132)",
//         borderColor: "#94a3b8",
//         data: reversedItemData.map((item) => item.Rate),
//       },
//     ],
//   };
//   const barchartdata = {
//     labels: reversedItemData.map((item) =>
//       new Date(item.ReceivedDate).toLocaleDateString("en-GB", {
//         weekday: "short",
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       })
//     ),
//     datasets: [
//       {
//         label: "Unit vs Time Chart",
//         backgroundColor: "#334155",
//         borderColor: "#334155",
//         data: reversedItemData.map((item) => item.UnitsOrdered),
//       },
//     ],
//   };

//   return (
//     <div className="flex flex-col min-h-screen">
//       <Navbar />
//       <div className="flex flex-col flex-grow">
//         <div className="mx-auto w-full max-w-5xl bg-white shadow-lg rounded-2xl p-6 space-y-5 mt-6">
//           <div className="flex justify-between items-center w-full">
//             <div className="flex gap-2 items-center">
//               <label className="font-poppins text-sm md:text-base mb-1 text-gray-600">
//                 From
//               </label>
//               <DatePicker
//                 selected={startDate}
//                 dateFormat="yyyy-MM-dd"
//                 onChange={(date) => setStartDate(date)}
//                 className="w-full md:w-40 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#003366]"
//               />
//             </div>

//             <OutletSearch
//               selectedOutlet={selectedOutlet}
//               setSelectedOutlet={setSelectedOutlet}
//               token={token}
//             />

//             <div className="flex gap-2 items-center">
//               <label className="font-poppins text-sm md:text-base mb-1 text-gray-600">
//                 To
//               </label>
//               <DatePicker
//                 selected={endDate}
//                 dateFormat="yyyy-MM-dd"
//                 onChange={(date) => setEndDate(date)}
//                 className="w-full md:w-40 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#003366]"
//               />
//             </div>

//           </div>

//           <div className="flex justify-center items-center gap-4">
//             <Selectitem
//               selectedItem={itemSelected}
//               setSelectedItem={changeItem}
//             />

//             <div>
//               <button
//                 className="flex items-center gap-1 px-4 py-2 rounded-sm font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm"
//                 onClick={handleItem}
//               >
//                 Search
//               </button>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <div className="max-w-5xl mx-auto mt-4 rounded-md bg-blue-50 p-4">
//             <div className="flex gap-3 items-center justify-center">
//               <MdAutorenew className="h-5 w-5 text-blue-300 animate-spin" />
//               <div className="text-blue-700">
//                 Loading report...
//               </div>
//             </div>
//           </div>
//         ) : error ? (
//           <div className="max-w-5xl mx-auto mt-4 rounded-md bg-red-50 p-4">
//             <div className="flex gap-3 justify-center items-stretch">
//               <MdError className="h-5 w-5 text-red-400" />
//               <div className="text-red-700">{error}</div>
//             </div>
//           </div>
//         ) : (status && (
//           <>
//             <div className="p-2 h-full md:h-[600px]">
//               <div className="w-full h-full md:h-[500px] overflow-y-scroll overflow-x-auto hover:shadow mt-2">
//                 <div className="flex justify-start w-full h-2/4 space-x-4">
//                   {" "}
//                   <div className="flex flex-col justify-start ml-10 w-1/4 border-2 border-gray-300 p-4 rounded-lg">
//                     <label className="font-serif font-bold">
//                       Item Name: {itemSelected.label}
//                     </label>
//                     <label className="font-serif font-bold">
//                       Department: {department}
//                     </label>
//                     <label className="font-serif font-bold">
//                       GroupName: {GroupName}
//                     </label>
//                     <label className="font-serif font-bold">
//                       Stock Type: {StockType}
//                     </label>
//                     <label className="font-serif font-bold">
//                       Taxable: {taxable}
//                     </label>
//                     <label className="font-serif font-bold">UOM: {UOM}</label>
//                   </div>
//                   <div className="flex justify-start w-3/4 ">
//                     {" "}
//                     <Line data={chartData} />
//                     <Bar data={barchartdata} />
//                   </div>
//                 </div>

//                 <table className="table-auto w-full bg-opacity-75 overflow-auto rounded-2xl text-center relative font-poppins text-sm md:text-base ">
//                   <thead className="md:h-10 lg:sticky lg:top-0 bg-slate-50 ">
//                     <tr className="mt-4 p-4 border-b-2 border-slate-400 md:my-5 ">
//                       <th>S.N</th>
//                       <th>Date</th>
//                       <th>Vendor Name</th>
//                       <th>UOM</th>
//                       <th>Qty</th>
//                       <th>Rate</th>
//                       <th>Total</th>
//                       <th>GRN</th>
//                     </tr>
//                   </thead>
//                   <tbody className="m-1 h-auto">
//                     {itemdata.length > 0 ? (
//                       itemdata.map((element, index) => (
//                         <tr className="h-auto" key={index}>
//                           <td>{index + 1}</td>
//                           <td>
//                             {new Date(element.ReceivedDate).toLocaleDateString(
//                               "en-GB",
//                               {
//                                 weekday: "short",
//                                 day: "2-digit",
//                                 month: "short",
//                                 year: "numeric",
//                               }
//                             )}
//                           </td>
//                           <td>{element.Company_Name}</td>
//                           <td>{element.UOM}</td>
//                           <td>{element.UnitsOrdered}</td>
//                           <td>{element.Rate}</td>
//                           <td>
//                             {isNaN(parseFloat(element.Total))
//                               ? "N/A"
//                               : parseFloat(element.Total).toFixed(2)}
//                           </td>

//                           <td>{element.GRN}</td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="7">No data available</td>
//                       </tr>
//                     )}
//                     <tr className="w-full h-14  bg-white p-4 sticky bottom-0 -z-0">
//                       <td className="font-bold">Count:{count}</td>
//                       <td></td>
//                       <td></td>
//                       <td className="font-bold">Qty:{totalQty.toFixed(2)}</td>
//                       <td></td>
//                       <td className="font-bold">
//                         Total:{totalAmount.toFixed(2)}
//                       </td>
//                       <td></td>
//                       <td></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             <div className="flex justify-around w-auto mt-0">
//               {/* Display error message */}
//               {error && (
//                 <div className="text-center text-red-500 mt-4">
//                   <strong>{error}</strong>
//                 </div>
//               )}

//               <div className="flex flex-col">
//                 {/* Kitchen Section */}
//                 <div className="flex flex-col">
//                   <div className="table-responsive-food">
//                     <div className="table-responsive-food-header">
//                       <div className="bg-heading-food">
//                         <h4 className="food-heading">Kitchen</h4>
//                       </div>
//                     </div>
//                     <div className="table-responsive">
//                       <table className="table-food">
//                         <thead className="table-background">
//                           <tr className="sticky-header bg-white">
//                             <th>Group Name</th>
//                             <th>Item Name</th>
//                             <th>Brand Name</th>
//                             <th>Amount</th>
//                             <th>UOM</th>
//                             <th>Rate</th>
//                             <th>Total</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {datakitchen.length > 0 ? (
//                             datakitchen.map((item, index) => (
//                               <tr key={index}>
//                                 <td>{item.GroupName}</td>
//                                 <td>{item.ItemName}</td>
//                                 <td>{item.BrandName || " "}</td>
//                                 <td>{item.Amount}</td>
//                                 <td>{item.UOM}</td>
//                                 <td>{item.Rate}</td>
//                                 <td>{item.Total}</td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="7" className="text-center">
//                                 No data available
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                         <tfoot className="w-full mt-1 bg-white p-2 sticky bottom-0 -z-0">
//                           <tr className="p-2 h-14 mb-0">
//                             <th></th>
//                             <th></th>
//                             <th></th>
//                             <th></th>
//                             <th></th>
//                             <th></th>
//                             <th>
//                               Total:{" "}
//                               <span className="text-base">
//                                 {datakitchentotal}
//                               </span>
//                             </th>
//                           </tr>
//                         </tfoot>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* Bar Section */}
//               <div className="flex flex-col">
//                 <div className="table-responsive-food">
//                   <div className="table-responsive-food-header">
//                     <div className="bg-heading-food">
//                       <h4 className="food-heading">Bar</h4>
//                     </div>
//                   </div>
//                   <div className="table-responsive">
//                     <table className="table-food">
//                       <thead className="table-background">
//                         <tr className="sticky-header bg-white">
//                           <th>Group Name</th>
//                           <th>Item Name</th>
//                           <th>Brand Name</th>
//                           <th>Amount</th>
//                           <th>UOM</th>
//                           <th>Rate</th>
//                           <th>Total</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {databar.length > 0 ? (
//                           databar.map((item, index) => (
//                             <tr key={index}>
//                               <td>{item.GroupName}</td>
//                               <td>{item.ItemName}</td>
//                               <td>{item.BrandName || " "}</td>
//                               <td>{item.Amount}</td>
//                               <td>{item.UOM}</td>
//                               <td>{item.Rate}</td>
//                               <td>{item.Total}</td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan="7" className="text-center">
//                               No data available
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                       <tfoot className="w-full mt-1 bg-white p-4 sticky bottom-0 -z-0">
//                         <tr className="p-4 h-14">
//                           <th></th>
//                           <th></th>
//                           <th></th>
//                           <th></th>
//                           <th></th>
//                           <th></th>
//                           <th>
//                             Total:{" "}
//                             <span className="text-base">{databartotal}</span>
//                           </th>
//                         </tr>
//                       </tfoot>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </>
//         ))}
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default ItemList;

















import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import Navbar from "../Navbar";
import Selectitem from ".";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import Footer from "../Footer";
import OutletSearch from "../SelectSearch/OutletSearch";
import { MdAutorenew, MdError } from "react-icons/md";
import { formatSalesValue } from "../../utils/formatUtils";
import ItemListTable from "./ItemListTable";

// Register the necessary components with ChartJS
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ItemList = () => {
  const params = new URLSearchParams(window.location.search);
  const item_name = params.get("item_name");

  const [itemSelected, setItemSelected] = useState(null);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [status, setStatus] = useState(false);
  const [itemdata, setItemData] = useState([]);
  const [department, setDepartment] = useState();
  const [taxable, setTaxable] = useState();
  const [GroupName, setGroupName] = useState();
  const [StockType, setStockType] = useState();
  const [UOM, setUOM] = useState("")
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [costCenters, setCostCenters] = useState([]);
  const [debitNotes, setDebitNotes] = useState([]);
  const [unitDefinition, setUnitDefintion] = useState({});
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false);

  const Url = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");
  const reversedItemData = itemdata.slice().reverse();

  const hasConsumedParam = useRef(false);
  const prevOutletKey = useRef(null);

  useEffect(() => {
    if (!selectedOutlet) return;

    const outletKey = selectedOutlet.id ?? selectedOutlet;

    // Same outlet as last time (just a new object reference) — ignore
    if (prevOutletKey.current === outletKey) return;
    prevOutletKey.current = outletKey;

    if (!hasConsumedParam.current && item_name) {
      hasConsumedParam.current = true;
      resetAll();
      setItemSelected(item_name);
      handleItem(item_name, startDate, endDate);
      return;
    }

    resetAll();
  }, [selectedOutlet]);

  const handleItem = async (item, start, end) => {
    if (!item || !selectedOutlet) {
      setError("Please select item and outlet.");
      return;
    }

    setLoading(true);
    setStatus(true);
    setError(null);

    try {
      const startFormatted = start ? start.toISOString().slice(0, 10) : "";
      const endFormatted = end ? end.toISOString().slice(0, 10) : "";

      const result = await axios.post(
        `${Url}/purchasefiltervendorwisefrompurchaseitem`,
        {
          token: token,
          item: item,
          dateStart: startFormatted,
          dateEnd: endFormatted,
          outlet: selectedOutlet,
        }
      );

      const purchaseData = result.data.purchase_data || [];
      const unitdefinition = result.data.unitdefinition || [];

      if (purchaseData.length > 0) {
        const firstItem = purchaseData[0];

        setDepartment(firstItem.Department);
        setGroupName(firstItem.GroupName);
        setTaxable(firstItem.Taxable);
        setStockType(firstItem.StockType);
        setUOM(firstItem.UOM);
      } else {
        setDepartment("");
        setGroupName("");
        setTaxable("");
        setStockType("");
        setUOM("");
      }

      setUnitDefintion(unitdefinition[0]);

      setItemData(result.data.purchase_data);
      setCostCenters(result.data.CostCenterIssuedData || []);
      setDebitNotes(result.data.debit_note_data || []);
    } catch (err) {
      console.log(err);
      setItemData([]);
      setCostCenters([]);
      setError(err?.response?.data?.error || err?.response?.data?.message || "Failed to fetch data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const debitNoteMap = debitNotes.reduce((acc, note) => {
    const grn = note.GRN;
    if (!acc[grn]) acc[grn] = [];
    acc[grn].push(note);
    return acc;
  }, {});

  const purchaseGRNs = new Set(itemdata.map(item => item.GRN));

  const unmatchedDebitNotes = debitNotes.filter(
    note => !purchaseGRNs.has(note.GRN)
  );

  const resetAll = () => {
    setItemSelected(null);
    setStartDate(undefined);
    setEndDate(undefined);
    setStatus(false);
    setItemData([]);
    setDepartment(undefined);
    setTaxable(undefined);
    setGroupName(undefined);
    setStockType(undefined);
    setUOM("");
    setCostCenters([]);
    setDebitNotes([]);
    setUnitDefintion({});
    setError(null);
  };

  const changeItem = (e) => {
    const ItemName = e;
    setItemSelected(ItemName);

    if (!ItemName) {
      setDepartment(undefined);
      setTaxable(undefined);
      setGroupName(undefined);
      setStockType(undefined);
      setUOM("");
      setItemData([]);
      setCostCenters([]);
      setDebitNotes([]);
      setUnitDefintion({});
      setStatus(false);
      setError(null);
      return;
    }

    handleItem(ItemName, "", "");
  };

  const calculateGrandTotals = () => {
    let totalQty = 0;
    let totalAmount = 0;

    itemdata.forEach((element) => {
      totalQty += parseFloat(element.UnitsOrdered) || 0;
      totalAmount += parseFloat(element.Total) || 0;
    });

    debitNotes.forEach((note) => {
      totalQty -= parseFloat(note.Quantity) || 0;
      totalAmount -= parseFloat(note.total_amount) || 0;
    });

    return { totalQty, totalAmount };
  };

  const { totalQty, totalAmount } = calculateGrandTotals();

  const calculateCostCenterTotals = () => {
    let totalQty = 0;

    if (costCenters?.items?.length > 0) {
      costCenters.items.forEach((item) => {
        totalQty += parseFloat(item.Amount) || 0;
      });
    }

    return { totalQty };
  };

  const { totalQty: costCenterQty } = calculateCostCenterTotals();

  const chartData = {
    labels: reversedItemData.map((item) =>
      new Date(item.ReceivedDate).toLocaleDateString("en-GB", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    ),
    datasets: [
      {
        label: "Price vs Time Chart",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#94a3b8",
        data: reversedItemData.map((item) => item.Rate),
      },
    ],
  };

  const barchartdata = {
    labels: reversedItemData.map((item) =>
      new Date(item.ReceivedDate).toLocaleDateString("en-GB", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    ),
    datasets: [
      {
        label: "Unit vs Time Chart",
        backgroundColor: "#334155",
        borderColor: "#334155",
        data: reversedItemData.map((item) => item.UnitsOrdered),
      },
    ],
  };

  const formatLocalDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const fetchData = () => {
    handleItem(itemSelected, startDate, endDate);
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <div className="flex-grow p-3">
        <div className="px-10 flex justify-between items-center pb-2">
          <div className="bg-white shadow-md rounded-xl p-3 border max-w-xs w-full space-y-1.5 text-sm">
            <h2 className="text-base font-semibold text-[#003366] border-b pb-2 mb-3">
              Item Details
            </h2>
            <div><span className="font-medium">Department:</span> {department}</div>
            <div><span className="font-medium">Group:</span> {GroupName}</div>
            <div><span className="font-medium">UOM:</span> {UOM}</div>
            <div><span className="font-medium">Stock Type:</span> {StockType}</div>
            <div><span className="font-medium">Taxable:</span> {taxable}</div>
          </div>

          <div className="mx-auto w-full max-w-3xl bg-white shadow-md rounded-xl p-4 space-y-4 text-sm">
            <div className="flex justify-between items-center w-full gap-2">

              <div className="flex gap-2 items-center z-50">
                <label className="text-gray-600">From</label>
                <DatePicker
                  selected={startDate}
                  dateFormat="yyyy-MM-dd"
                  onChange={(date) => setStartDate(date)}
                  className="w-24 border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-[#003366] cursor-pointer"
                />
              </div>

              <div className="z-50">
                <OutletSearch
                  selectedOutlet={selectedOutlet}
                  setSelectedOutlet={setSelectedOutlet}
                  token={token}
                />
              </div>

              <div className="flex gap-2 items-center z-50">
                <label className="text-gray-600">To</label>
                <DatePicker
                  selected={endDate}
                  dateFormat="yyyy-MM-dd"
                  onChange={(date) => setEndDate(date)}
                  className="w-24 border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-[#003366] cursor-pointer"
                />
              </div>

            </div>

            <div className="flex justify-center items-center gap-6">
              <div className="z-40">
                <Selectitem
                  selectedItem={itemSelected}
                  setSelectedItem={changeItem}
                />
              </div>

              <button
                className="px-4 py-2 rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 text-sm"
                onClick={() => handleItem(itemSelected, startDate, endDate)}
              >
                Search
              </button>
            </div>
          </div>

          <div className="max-w-xs w-full">
            <div className="bg-white shadow-md rounded-xl p-4 border max-w-xs w-full space-y-1.5 text-sm">
              <h2 className="text-base font-semibold text-[#003366] border-b pb-2 mb-3">
                Unit Definition
              </h2>
              <div><span className="font-medium">Unit:</span> {unitDefinition?.unit}</div>
              <div><span className="font-medium">UOM:</span> {unitDefinition?.uom}</div>
              <div><span className="font-medium">Rate:</span> {unitDefinition?.rate}</div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="max-w-5xl mx-auto mt-4 rounded-md bg-blue-50 p-4">
            <div className="flex gap-3 items-center justify-center">
              <MdAutorenew className="h-5 w-5 text-blue-300 animate-spin" />
              <div className="text-blue-700">
                Loading report...
              </div>
            </div>
          </div>
        ) : error ? (
          <div className="max-w-5xl mx-auto mt-4 rounded-md bg-red-50 p-4">
            <div className="flex gap-3 justify-center items-stretch">
              <MdError className="h-5 w-5 text-red-400" />
              <div className="text-red-700">{error}</div>
            </div>
          </div>
        ) : (status && (
          <ItemListTable
            itemdata={itemdata}
            debitNoteMap={debitNoteMap}
            unmatchedDebitNotes={unmatchedDebitNotes}
            costCenters={costCenters}
            totalQty={totalQty}
            totalAmount={totalAmount}
            costCenterQty={costCenterQty}
            chartData={chartData}
            barchartdata={barchartdata}
            formatLocalDate={formatLocalDate}
            formatSalesValue={formatSalesValue}
            baseUrl={Url}
            token={token}
            fetchData={fetchData}
          />
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default ItemList;
